<template>
  <div class="alarm-detail">
    <div class="back" @click="goBack">
      <a-button type="primary"><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button>
    </div>

    <div class="detail-content">

      <div class="info-section">
        <div class="section-title">告警信息</div>
        <div class="info-grid">
          <div class="info-item">
            <span class="label">告警类型</span>
            <span class="value">{{ getAlarmType(alarmInfo.type) }}</span>
          </div>
          <div class="info-item">
            <span class="label">触发围栏名称</span>
            <span class="value">{{ alarmInfo.fenceName || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">告警信息</span>
            <span class="value">{{ alarmInfo.info || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">告警时间</span>
            <span class="value">{{ alarmInfo.occurTime || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">处理状态</span>
            <span class="value">{{ getStatusText(alarmInfo.status) }}</span>
          </div>
          <div class="info-item">
            <span class="label">处理备注</span>
            <span class="value">{{ alarmInfo.remark || '-' }}</span>
          </div>
        </div>
      </div>

      <div class="info-section">
        <div class="section-title">车辆信息</div>
        
        <div class="info-grid">
          <div class="info-item">
            <span class="label">车辆编码</span>
            <span class="value">{{ alarmInfo.licenceNo || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">车辆识别码</span>
            <span class="value">{{ alarmInfo.vin || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">申请主体</span>
            <span class="value">{{ alarmInfo.providerName || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">运营主体</span>
            <span class="value">{{ alarmInfo.operatorName || '-' }}</span>
          </div>
        </div>

        <div class="safety-section">
          <div class="section-subtitle">安全员信息</div>
          <div class="safety-list">
            <div v-for="(officer, index) in alarmInfo.safetyOfficers" :key="index" class="safety-item">
              <span class="safety-name">姓名：{{ officer.name }}</span>
              <span class="safety-phone">联系方式：{{ officer.phone }}</span>
            </div>
            <div v-if="!alarmInfo.safetyOfficers || alarmInfo.safetyOfficers.length === 0" class="safety-empty">
              暂无安全员信息
            </div>
          </div>
        </div>

        <div class="enterprise-section">
          <div class="section-subtitle">运营企业信息</div>
          <div class="info-grid">
            <div class="info-item">
              <span class="label">企业名称</span>
              <span class="value">{{ alarmInfo.company?.name || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">企业地址</span>
              <span class="value">{{ alarmInfo.company?.address || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">联系人</span>
              <span class="value">{{ alarmInfo.company?.linkName || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">联系电话</span>
              <span class="value">{{ alarmInfo.company?.linkPhone || '-' }}</span>
            </div>
          </div>
        </div>
      </div>


      <div class="track-section">
        <div class="section-title">事件轨迹</div>
        <div class="track-content">
          <div class="realtime-info">
            <div class="realtime-title">车辆实况信息</div>
            <div class="realtime-grid">
              <div class="realtime-item">
                <span class="realtime-label">车速</span>
                <span class="realtime-value">{{ alarmInfo.vehicleInfo?.speed || '-' }} km/h</span>
              </div>
              <div class="realtime-item">
                <span class="realtime-label">位置坐标</span>
                <span class="realtime-value">{{ formatLocation(alarmInfo.vehicleInfo?.location) }}</span>
              </div>
              <div class="realtime-item">
                <span class="realtime-label">加速度值</span>
                <span class="realtime-value">{{ alarmInfo.vehicleInfo?.acceleration || '-' }} m/s²</span>
              </div>
              <div class="realtime-item">
                <span class="realtime-label">驾驶模式</span>
                <span class="realtime-value">{{ alarmInfo.vehicleInfo?.drivingMode || '-' }}</span>
              </div>
              <div class="realtime-item">
                <span class="realtime-label">正向行驶角</span>
                <span class="realtime-value">{{ alarmInfo.vehicleInfo?.headingAngle || '-' }}°</span>
              </div>
              <div class="realtime-item">
                <span class="realtime-label">大灯状态</span>
                <span class="realtime-value">{{ getLightStatus(alarmInfo.vehicleInfo?.headlightStatus) }}</span>
              </div>
              <div class="realtime-item">
                <span class="realtime-label">刹车灯状态</span>
                <span class="realtime-value">{{ getLightStatus(alarmInfo.vehicleInfo?.brakeLightStatus) }}</span>
              </div>
              <div class="realtime-item">
                <span class="realtime-label">左转向灯状态</span>
                <span class="realtime-value">{{ getLightStatus(alarmInfo.vehicleInfo?.leftTurnLightStatus) }}</span>
              </div>
              <div class="realtime-item">
                <span class="realtime-label">右转向灯状态</span>
                <span class="realtime-value">{{ getLightStatus(alarmInfo.vehicleInfo?.rightTurnLightStatus) }}</span>
              </div>
            </div>
            
          </div>
          <div class="map-panel">
            <div class="map-container" id="map-container"></div>
            <!-- 触发告警的围栏信息浮层 -->
            <div v-if="alarmInfo.fenceInfo && fenceInfoVisible" class="fence-info-overlay">
              <div class="fence-info-header">
                <span class="fence-info-title">{{ alarmInfo.fenceInfo.fenceName || '围栏信息' }}</span>
                <a class="fence-info-close" @click="fenceInfoVisible = false">×</a>
              </div>
              <div class="fence-info-content">
                <div class="fence-info-section">
                  <div class="section-label">基本信息</div>
                  <div class="fence-info-row">
                    <span class="fence-info-label">城市</span>
                    <span class="fence-info-value">{{ alarmInfo.fenceInfo.cityName || '-' }}</span>
                  </div>
                  <div class="fence-info-row">
                    <span class="fence-info-label">区域</span>
                    <span class="fence-info-value">{{ alarmInfo.fenceInfo.areaName || '-' }}</span>
                  </div>
                  <div class="fence-info-row">
                    <span class="fence-info-label">方向</span>
                    <span class="fence-info-value">{{ getDirectionText(alarmInfo.fenceInfo.direction) }}</span>
                  </div>
                  <div class="fence-info-row">
                    <span class="fence-info-label">缓冲距离</span>
                    <span class="fence-info-value">{{ alarmInfo.fenceInfo.bufferDistance != null ? alarmInfo.fenceInfo.bufferDistance + ' m' : '-' }}</span>
                  </div>
                  <div class="fence-info-row">
                    <span class="fence-info-label">最小限速</span>
                    <span class="fence-info-value">{{ alarmInfo.fenceInfo.minSpeed != null ? alarmInfo.fenceInfo.minSpeed + ' km/h' : '-' }}</span>
                  </div>
                  <div class="fence-info-row">
                    <span class="fence-info-label">最大限速</span>
                    <span class="fence-info-value">{{ alarmInfo.fenceInfo.maxSpeed != null ? alarmInfo.fenceInfo.maxSpeed + ' km/h' : '-' }}</span>
                  </div>
                </div>
                <div
                  v-if="alarmInfo.fenceInfo.policyList && alarmInfo.fenceInfo.policyList.length > 0"
                  class="fence-info-section"
                >
                  <div class="section-label">策略列表</div>
                  <div v-for="(policy, idx) in alarmInfo.fenceInfo.policyList" :key="idx" class="policy-card">
                    <div class="fence-info-row">
                      <span class="fence-info-label">规则名称</span>
                      <span class="fence-info-value">{{ policy.ruleName || '-' }}</span>
                    </div>
                    <div class="fence-info-row">
                      <span class="fence-info-label">规则类型</span>
                      <span class="fence-info-value">{{ getRuleTypeText(policy.ruleType) }}</span>
                    </div>
                    <div class="fence-info-row">
                      <span class="fence-info-label">适用日期</span>
                      <span class="fence-info-value">{{ getRuleWeekDaysText(policy) }}</span>
                    </div>
                    <div class="fence-info-row">
                      <span class="fence-info-label">禁行时段</span>
                      <span class="fence-info-value">{{ getRuleTimeSlotsText(policy.timeSlots) }}</span>
                    </div>
                    <div class="fence-info-row">
                      <span class="fence-info-label">优先级</span>
                      <span class="fence-info-value">{{ policy.priority ?? '-' }}</span>
                    </div>
                    <div class="fence-info-row">
                      <span class="fence-info-label">生效日期</span>
                      <span class="fence-info-value">{{ policy.effectiveStartDate || '-' }} ~ {{ policy.effectiveEndDate || '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, shallowRef, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import AMapLoader from '@amap/amap-jsapi-loader'
import { message } from 'ant-design-vue';
import { getAlarmDetail } from '@/api/alarm/index';
import { getStatusText, getAlarmType } from './components/EnumUtils'

const router = useRouter();
const route = useRoute();
const alarmId = route.query.alarmId;
const alarmInfo = ref({});
// 围栏信息浮层显示状态
const fenceInfoVisible = ref(true);
const map = shallowRef(null);
let AMapInstance = null;
// 触发告警的围栏覆盖物
let fenceOverlays = [];

const trackPoints = computed(() => {
  const track = alarmInfo.value.vehicleInfo?.boundaryTrack || [];
  return track.map(point => {
    try {
      const loc = JSON.parse(point);
      return `经度: ${loc[0]}, 纬度: ${loc[1]}`;
    } catch {
      return point;
    }
  });
});

const goBack = () => {
  router.push('/test/alarm');
};

const formatLocation = (location) => {
  if (!location) return '-';
  try {
    const loc = JSON.parse(location);
    return `经度: ${loc[0]}, 纬度: ${loc[1]}`;
  } catch {
    return location;
  }
};

const getLightStatus = (status) => {
  if (status === undefined || status === null) return '-';
  return status === 1 || status === true || status === '1' || status === '开启' ? '开启' : '关闭';
};

// ========== 围栏信息显示辅助 ==========
const getDirectionText = (direction) => {
  const map = { 0: '双向', 1: '正向', 2: '反向' };
  return map[direction] ?? '-';
};

const getRuleTypeText = (type) => {
  return { 1: '按星期循环', 2: '按具体日期' }[type] || '-';
};

const weekDayText = (d) => ({
  1: '周一', 2: '周二', 3: '周三', 4: '周四',
  5: '周五', 6: '周六', 7: '周日',
}[d]);

const getRuleWeekDaysText = (rule) => {
  if (rule.ruleType === 1) {
    if (!rule.weekDays) return '-';
    return rule.weekDays.split(',').map(Number).map(weekDayText).join('、');
  }
  if (rule.ruleType === 2) {
    if (!rule.startDate || !rule.endDate) return '-';
    return `${rule.startDate} ~ ${rule.endDate}`;
  }
  return '-';
};

const getRuleTimeSlotsText = (timeSlots) => {
  let slots = timeSlots;
  if (typeof slots === 'string') {
    try { slots = JSON.parse(slots); } catch (e) { return '-'; }
  }
  if (!Array.isArray(slots) || slots.length === 0) return '-';
  return slots.map((s) => `${s.start}-${s.end}`).join('，');
};

// 事件触发位置（GCJ-02 经纬度）
const getOccurCoordinate = () => {
  const lon = Number(alarmInfo.value.occurGcj02Lon);
  const lat = Number(alarmInfo.value.occurGcj02Lat);
  if (!Number.isFinite(lon) || !Number.isFinite(lat)) return null;
  if (lon === 0 && lat === 0) return null;
  return [lon, lat];
};

// 解析围栏几何数据（geometry 为 GeoJSON 字符串）
const parseFenceGeometry = (fenceInfo) => {
  if (!fenceInfo?.geometry) return null;
  try {
    return typeof fenceInfo.geometry === 'string' ? JSON.parse(fenceInfo.geometry) : fenceInfo.geometry;
  } catch (error) {
    console.error('解析围栏几何数据失败:', error);
    return null;
  }
};

// 创建围栏覆盖物（红色，表示禁行区）
const createFenceOverlay = (geometry) => {
  if (!geometry || !AMapInstance) return null;
  const { type, coordinates } = geometry;
  const color = '#ff4d4f';
  if (type === 'Polygon') {
    const ring = coordinates?.[0] || [];
    const path = ring.map(([lng, lat]) => new AMapInstance.LngLat(lng, lat));
    return new AMapInstance.Polygon({
      path,
      fillColor: color,
      fillOpacity: 0.15,
      strokeColor: color,
      strokeWeight: 2,
      zIndex: 20
    });
  }
  if (type === 'LineString') {
    const path = coordinates.map(([lng, lat]) => new AMapInstance.LngLat(lng, lat));
    return new AMapInstance.Polyline({
      path,
      strokeColor: color,
      strokeWeight: 4,
      strokeOpacity: 0.85,
      zIndex: 20
    });
  }
  if (type === 'Point') {
    const [lng, lat] = coordinates;
    return new AMapInstance.Marker({ position: [lng, lat], zIndex: 20 });
  }
  return null;
};

const initMap = async () => {
  try {
    const AMap = await AMapLoader.load({
      key: '6588d9e5b6ae0751c799cb4c7b3e30be',
      version: '2.0',
      plugins: ['AMap.Marker', 'AMap.Polyline', 'AMap.Polygon']
    });
    AMapInstance = AMap;

    const vehicleInfo = alarmInfo.value.vehicleInfo;
    const occurCoord = getOccurCoordinate();
    let center = [103.726465, 36.107992];
    if (occurCoord) {
      center = occurCoord;
    } else if (vehicleInfo?.location) {
      try { center = JSON.parse(vehicleInfo.location); } catch (e) { /* ignore */ }
    }

    map.value = new AMap.Map('map-container', {
      zoom: occurCoord ? 16 : 15,
      mapStyle: 'amap://styles/whitesmoke',
      center: center
    });

    // 参与视野自适应的覆盖物集合
    const fitOverlays = [];

    // 1. 绘制触发告警的围栏（红色，表示禁行区）
    const fenceGeometry = parseFenceGeometry(alarmInfo.value.fenceInfo);
    if (fenceGeometry) {
      const fenceOverlay = createFenceOverlay(fenceGeometry);
      if (fenceOverlay) {
        fenceOverlay.setMap(map.value);
        fenceOverlays.push(fenceOverlay);
        fitOverlays.push(fenceOverlay);
      }
    }

    // 2. 标记事件触发时的位置
    if (occurCoord) {
      const occurMarker = new AMap.Marker({
        position: occurCoord,
        content: `<div style="display:flex;align-items:center;gap:4px;white-space:nowrap;"><div style="width:30px;height:30px;border-radius:50%;background:#ff4d4f;color:#fff;font-size:12px;line-height:30px;text-align:center;border:2px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,0.35);">警</div><span style="font-size:12px;color:#333;background:rgba(255,255,255,0.92);padding:2px 6px;border-radius:4px;box-shadow:0 1px 4px rgba(0,0,0,0.2);">告警位置</span></div>`,
        offset: new AMap.Pixel(-15, -15),
        zIndex: 120
      });
      occurMarker.setMap(map.value);
      fitOverlays.push(occurMarker);
    }

    // 3. 绘制事件轨迹
    if (vehicleInfo?.boundaryTrack && vehicleInfo.boundaryTrack.length > 0) {
      const path = vehicleInfo.boundaryTrack.map(point => JSON.parse(point));

      const trackLine = new AMap.Polyline({
        path: path,
        strokeColor: "#F5222D",
        strokeWeight: 5,
        strokeOpacity: 0.9,
        zIndex: 50
      });
      trackLine.setMap(map.value);
      fitOverlays.push(trackLine);

      path.forEach((point, index) => {
        new AMap.Marker({
          position: point,
          icon: new AMap.Icon({
            size: new AMap.Size(20, 20),
            image: index === path.length - 1
              ? 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png'
              : 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
            imageSize: new AMap.Size(20, 20)
          }),
          label: {
            content: `点${index + 1}`,
            offset: new AMap.Pixel(10, 0)
          }
        }).addTo(map.value);
      });
    }

    // 4. 无围栏、无触发位置、无轨迹时兜底显示车辆位置
    if (fitOverlays.length === 0) {
      new AMap.Marker({
        position: center,
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png'
      }).addTo(map.value);
    }

    // 5. 视野：优先聚焦到告警发生点位附近，其次按覆盖物自适应
    if (occurCoord) {
      map.value.setZoomAndCenter(16, occurCoord);
    } else if (fitOverlays.length > 0) {
      map.value.setFitView(fitOverlays, true, [60, 60, 60, 60]);
    }

  } catch (error) {
    console.error('地图加载失败:', error);
  }
};

const destroyMap = () => {
  fenceOverlays = [];
  if (map.value) {
    map.value.destroy();
    map.value = null;
  }
};

// 获取告警详情
const getDetail = async () => {
  if (!alarmId) {
    message.error('缺少告警ID');
    return;
  }
  try {
    const res = await getAlarmDetail(alarmId);
    if (res.code === 200) {
      alarmInfo.value = res.data || {};
      initMap();
    }
  } catch (error) {
    console.error('获取告警详情失败:', error);
    message.error('获取告警详情失败');
  }
};

onMounted(() => {
  getDetail();
});

onBeforeUnmount(() => {
  destroyMap();
});
</script>

<style lang="less" scoped>
.alarm-detail {
  padding: 20px;
  background-color: #ffffff;
  min-height: calc(100vh - 70px - 57px);
}

.back {
  position: fixed;
  top: 93px;
  right: 50px;
  z-index: 20;
}

.detail-content {
  background: #F7F8FA;
  border-radius: 8px;
  padding: 20px;
}

.info-section {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #0A212E;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #E1E7EF;
}

.section-subtitle {
  font-size: 14px;
  font-weight: bold;
  color: #0A212E;
  margin: 16px 0 12px 0;
  padding-left: 8px;
  border-left: 3px solid #1E8EF2;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;

  .label {
    font-size: 14px;
    color: #68767E;
    margin-bottom: 8px;
  }

  .value {
    font-size: 14px;
    color: #0A212E;
    font-weight: 500;
  }
}

.enterprise-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #E1E7EF;
}

.safety-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #E1E7EF;
}

.safety-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.safety-item {
  background: #F7F8FA;
  padding: 12px 16px;
  border-radius: 4px;
  min-width: 200px;
}

.safety-name {
  display: block;
  font-size: 14px;
  color: #0A212E;
  margin-bottom: 4px;
}

.safety-phone {
  font-size: 14px;
  color: #68767E;
}

.safety-empty {
  font-size: 14px;
  color: #999999;
}

.track-section {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
}

.track-content {
  display: flex;
  gap: 20px;
}

.realtime-info {
  width: 350px;
  flex-shrink: 0;
  background: #F7F8FA;
  border-radius: 8px;
  padding: 16px;
}

.realtime-title {
  font-size: 14px;
  font-weight: bold;
  color: #0A212E;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #E1E7EF;
}

.realtime-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.realtime-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.realtime-label {
  font-size: 14px;
  color: #68767E;
}

.realtime-value {
  font-size: 14px;
  color: #0A212E;
  font-weight: 500;
}

.track-points {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #E1E7EF;
}

.track-points-title {
  font-size: 14px;
  font-weight: bold;
  color: #0A212E;
  margin-bottom: 12px;
}

.track-point {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px dashed #E1E7EF;

  &:last-child {
    border-bottom: none;
  }
}

.point-label {
  font-size: 14px;
  color: #68767E;
}

.point-coord {
  font-size: 14px;
  color: #0A212E;
}

.map-panel {
  position: relative;
  flex: 1;
  min-width: 0;
  height: 500px;
  border-radius: 8px;
  overflow: hidden;
}

.map-container {
  width: 100%;
  height: 100%;
  border: 1px solid #E1E7EF;
  border-radius: 8px;
}

.fence-info-overlay {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 380px;
  max-height: calc(100% - 24px);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  z-index: 10;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .fence-info-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: linear-gradient(135deg, #1890ff, #096dd9);

    .fence-info-title {
      font-size: 15px;
      font-weight: 600;
      color: #fff;
    }

    .fence-info-close {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.8);
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
        color: #fff;
      }
    }
  }

  .fence-info-content {
    flex: 1;
    overflow-y: auto;
    padding: 4px 0;
  }

  .fence-info-section {
    padding: 8px 16px;

    .section-label {
      font-size: 12px;
      font-weight: 600;
      color: #8c8c8c;
      margin-bottom: 6px;
      padding-left: 6px;
      border-left: 3px solid #1890ff;
      line-height: 1;
    }
  }

  .fence-info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
    line-height: 1.5;

    .fence-info-label {
      font-size: 13px;
      color: #8c8c8c;
      flex-shrink: 0;
      white-space: nowrap;
    }

    .fence-info-value {
      font-size: 13px;
      color: #262626;
      text-align: right;
      margin-left: 12px;
      word-break: break-all;
    }
  }

  .policy-card {
    background: #f5f7fa;
    border-radius: 6px;
    padding: 10px 12px;
    margin: 6px 0;
    border-left: 3px solid #52c41a;
  }
}

/deep/ .amap-logo {
  display: none !important;
}

/deep/ .amap-copyright {
  opacity: 0 !important;
}
</style>